import React, {useContext} from 'react'
import Context from '../context'
import Moment from 'react-moment'

const styles = {
    
    ch: {
        width: "auto"
    },
    prior: {
        width: "40px",
    },
    date: {
        width: "auto"
    }
}


export default function TodoItem({ todo, index, onChange, onChange2, onChange3, onChange4}) {

    const {removeTodo} = useContext(Context)
    const classes = []
    if (todo.completed) {
         classes.push('done')
    }

      const today = new Date()
    const tomorrow = new Date(Date.now() + (3600 * 1000 * 24))
    if (Date.parse(todo.date) <Date.parse(today.toISOString().split('T')[0])) {
 console.log('todo.date', todo.date, ' today', today.toISOString().split('T')[0])
        classes.push('lost')
    }
    if (Date.parse(todo.date) ===Date.parse(today.toISOString().split('T')[0])) {
 console.log('todo.date', todo.date, ' today', today.toISOString().split('T')[0])
        classes.push('hard')
    }
  
 console.log('todo.date', todo.date, ' tomorrow', Date.parse(tomorrow.toISOString().split('T')[0]))

    if (Date.parse(todo.date) ===  Date.parse(tomorrow.toISOString().split('T')[0])) {
        classes.push('near')
    }
    function onDate(_id) {
        document.getElementById('datebefore'+_id).style.display = "none"
        document.getElementById('dateafter'+_id).style.display = "block"
    }
    function onText(_id) {
        document.getElementById('textbefore' + _id).style.display = "none"
        document.getElementById('textafter'+_id).style.display = "block"
    }

    return (
               
            <tr className={classes.join(' ')}>
                    <td style={styles.ch}> <input
                    type="checkbox"
                    checked={todo.completed}
                    onChange={() => onChange(todo._id)}
                    />
                    </td>
                    <td style={styles.ch}><strong>{index + 1}</strong></td>
                <td id={'datebefore'+todo._id} onClick={()=>onDate(todo._id)} style={{display: 'block'},styles.date}><Moment format="DD.MM" date={Date.parse(todo.date)} className="date" /></td>
          <span className="textareaContainer">
            <input className="datesmall" type="date" id={'dateafter' + todo._id} onChange={(e) => onChange3(todo._id, e.target.value)} defaultValue={todo.date} style={{ display: 'none' }} />
            <td id={'textbefore' + todo._id} onClick={() => onText(todo._id)}>{todo.title} </td>
                <textarea id={'textafter'+todo._id}  style={{display: 'none'}}  onChange={(e) => onChange4(todo._id, e.target.value)}>{todo.title}</textarea>
               </span>
                    <td style={styles.ch}>
                    <input
                        type="number"
                        defaultValue ={todo.priority}
                        style={styles.prior}
                        onChange={(e) => onChange2(todo._id, e.target.value)}
                        min={0}
                        inputmode="numeric"
                        />
                    </td>
                    <td style={styles.ch}>
                        <button className="bat" onClick={removeTodo.bind(null, todo._id)}>&times;</button>
                    </td>
                    </tr>
               
                
    )
}

